import { useSelector } from "react-redux";
import { translations } from "./translations";

// Field definition type
interface fieldTranslation {
  en: string;
  zh: string;
}

export const useTranslation = () => {
  const language = useSelector((state: any) => state.configurations.language);
  console.log("language", language);
  const t = (key: keyof typeof translations): string => {
    // Failsafe for missing translation keys. Fallback to English if not found, so it wont crash the app.
    if (!translations[key]) {
      console.warn("Missing translation key:", key);
      return String(key);
    }
    return translations[key][language] || translations[key]["en"] || String(key);
  };

  return { t };
};

export const translateHeaders = (
  headers: Record<string, any>,
  t: (key: keyof typeof translations) => string,
  translationMap: any
) => {
  return Object.fromEntries(
    Object.entries(headers).map(([key, value]) => {
      const translationKey = translationMap[key];
      const translatedName = translationKey ? t(translationKey) : value.name;
      return [key, { ...value, name: translatedName }];
    })
  );
};

export const translateFields = (
  key: string,
  t: (key: keyof typeof translations) => string,
  translationMap: any
) => {
  const translationKey = translationMap[key];
  const translatedName = translationKey ? t(translationKey) : "";
  return translatedName;
};

export const getTranslationKeyByValue = (
  value: string,
  language: "en" | "zh"
): string | undefined => {
  for (const [key, translation] of Object.entries(translations)) {
    if (
      typeof translation === "object" &&
      translation !== null &&
      translation[language] === value
    ) {
      return translation["en"];
    }
  }
  return undefined;
};
